import {priority, wcfclient} from '@priority-software/priority-proto-api/lib';
import {getAdditionalProps} from '../../../../services/proto/core/loginProps';
import {onboardingSessions} from './api_session';
import {handleMessage} from './general';

export const getBankData = async (form, cols) => {
    try {
        const res = await wcfclient.recordsFetch(
            new priority.netitems.form.FetchRq({
                Session: form.Session,
                Properties: getAdditionalProps(),
                Filters: [
                    {
                        Condition: [
                            {
                                ColumnID: cols.Columns.find(col => col.Name === 'MAINBANKFLAG')?.ID,
                                Operator: priority.netitems.shared.ComparisonOperator.Eq,
                                Values: ['Y ']
                            }
                        ]
                    }
                ]
            })
        );

        handleMessage(res.Messages, form.Session);

        return res;
    } catch (e) {
        onboardingSessions.removeFormByKey(form.formName);
        throw new Error((e as Error).message);
    }
};
